import analytics from '@utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Section from '@components/common/Section';
const ExchangeInBoutique = (props) => {
    const { t } = useTranslation();
    return (React.createElement(Section, { title: t('exchanges.exchangeinboutique') },
        React.createElement("div", { className: "client-service__column-wrapper" },
            React.createElement("div", null,
                React.createElement("div", { className: "section__description", dangerouslySetInnerHTML: { __html: t('returns.boutiqueintro') } }),
                React.createElement("a", { href: props.boutiqueurl, className: "button button--secondary", onClick: () => analytics.exchangeStepOneBoutique('locator') },
                    React.createElement("span", null, t('button.boutiquelocator')))),
            React.createElement("div", null,
                React.createElement("div", { className: "section__description", dangerouslySetInnerHTML: { __html: t('exchanges.stylingopportunities') } }),
                React.createElement("a", { href: props.locatorurl, className: "button button--secondary", onClick: () => analytics.exchangeStepOneBoutique('appointment') },
                    React.createElement("span", null, t('button.bookappointment')))))));
};
export default ExchangeInBoutique;
